<template>
  <vue-timepicker
    format="hh:mm A"
    class="time-picker"
    :value="value"
    @input="$emit('change', $event)"
  >
  </vue-timepicker>
</template>

<script>
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";

  export default {
    name: "Time",
    props: {
      id: String,
      value: Object
    },
    components: {
      VueTimepicker
    }
  };
</script>

<style lang="scss">
  .time-picker {
    display: block;
    width: 100%;
    font-family: inherit;
    font-size: inherit;

    input.display-time {
      padding: 10px 5px;
      border: $border;
      border-radius: $radius;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      width: 100%;
      height: auto;
    }
  }
</style>
